/**
 * Status badge derivation for the superadmin Organizations list — replaces
 * the legacy per-row background-color (rowBgClass) + separate "Table colors
 * explanation" legend with one self-describing Badge per row. Precedence
 * mirrors the old TableRow.js logic exactly (first match wins, trial takes
 * priority over a terminated flag, matching that this was never overridden
 * in the original code's trial branch) — just expressed as a label instead
 * of a Bootstrap table-* class, so it no longer needs an external legend.
 *
 * @param {Object=} currentPlan - organizations_plans[0] (most recent plan,
 *   the API orders this DESC by created), or null/undefined if the org
 *   never subscribed
 * @returns {{color: 'gray'|'brand'|'success'|'warning'|'error', label: string}}
 */
import { PLANS } from "../../../../consts";

export function getOrganizationStatus(currentPlan) {
  if (!currentPlan || !currentPlan.name) {
    return { color: "gray", label: "Inactive" };
  }

  const available = Number(currentPlan.available) === 1;
  const isTrial = Number(currentPlan.is_trial) === 1;
  const isTerminated = Number(currentPlan.is_terminated) === 1;
  const isFree = currentPlan.plan_code === PLANS.free;
  const now = Math.floor(Date.now() / 1000);
  const expired =
    currentPlan.expiry != null && Number(currentPlan.expiry) < now;

  if (!available) {
    return isTerminated
      ? { color: "error", label: "Cancelled" }
      : { color: "gray", label: "Inactive" };
  }

  if (isTrial) {
    return { color: "brand", label: "Trial" };
  }

  if (isTerminated) {
    return { color: "warning", label: "Cancelling" };
  }

  if (isFree) {
    return { color: "gray", label: "Free" };
  }

  if (expired) {
    return { color: "gray", label: "Payment issue" };
  }

  return { color: "success", label: "Active" };
}
